/**
 * A list of values that can be hardware-accelerated.
 */
export const acceleratedValues = new Set<string>([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor",
])
